<template>
  <div >
      <router-view> </router-view>
  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-notifyjs/themes/default.css'
  export default {
 
}
</script>
<style lang="scss">

</style>
